module.exports = __webpack_public_path__ + "img/michelle-smc.e66f448e.jpg";